var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline"},[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingBtn},on:{"click":_vm.downloadInstructive}},[_c('v-icon',{staticClass:"mr-3",attrs:{"size":"20"}},[_vm._v("fa-file-pdf")]),_vm._v(" "+_vm._s(_vm.$t('evaluations.download_instructive'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }